import { render, staticRenderFns } from "./qualificationsType.vue?vue&type=template&id=2c6a1aae"
import script from "./qualificationsType.vue?vue&type=script&lang=js"
export * from "./qualificationsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports